import React from 'react';
import ReactDOM from 'react-dom';

import Header from './Common/Header';
import Footer from './Common/Footer';

import Home from './Pages/Home';
import Repair from './Pages/Repair';
import About from './Pages/About';
import Contact from './Pages/Contact';
import CycleRent from './Pages/CycleRent';

import ProductListing from './Pages/Products/Listings';
import ProductDescription from './Pages/Products/ProductDescription';

import registerServiceWorker from './registerServiceWorker';
 
import {
    BrowserRouter as Router,
    Route,
} from 'react-router-dom';

ReactDOM.render(

    <Router>
        <main>
            <Header />

            <Route path="/" exact={true} component={Home} />

            <Route path="/cycles" exact={true} component={ProductListing} />
            <Route path="/accessories" exact={true}  component={ProductListing} />
            
            <Route path="/cycle/:page_uri" exact={true}  component={ProductDescription} />
            <Route path="/accessory/:page_uri" exact={true}  component={ProductDescription} />

            <Route path="/repairs" exact={true} component={Repair} />
            <Route path="/rent-a-cycle" exact={true} component={CycleRent} />

            <Route path="/about" exact={true} component={About} />
            <Route path="/contact" exact={true} component={Contact} />
            
            <Footer />            
        </main> 
    </Router>
    
, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js